import { useRef } from "react";

import { newRelic } from "utils/logUtils";
import { trackEventVideoRenderedError } from "utils/gAnalyticsUtils";

import { jjLogger } from "../utils/logUtils";

const useWebGlPlayer = (params) => {
  const transportRef = useRef(null);
  const playerRef = useRef(null);

  const init = (onLoaded = null, onFailed = null) => {
    try {
      import("webgl-render-library").then((renderLib) => {
        const { SYPlayer, Transport } = renderLib;

        playerRef.current = new SYPlayer(params);
        playerRef.current.addEventListener("loaded", (event) => {
          transportRef.current = new Transport(event.currentTarget); // eslint-disable-line
          if (typeof onLoaded === "function") onLoaded(event);
        });
      });
    } catch (error) {
      if (typeof onFailed === "function") onFailed(error);
      jjLogger.log(error.message);
      newRelic(`WebGL Player Error: ${error.message}`, error);
      trackEventVideoRenderedError("WebGL");
    }
  };

  const cleanup = () => {
    playerRef.current.removeEventListener("loaded", null);
    playerRef.current.destroy();

    if (transportRef.current) {
      transportRef.current.destroy();
    }

    playerRef.current = null;
    transportRef.current = null;
  };

  const exitFullscreen = () => transportRef.current.closeFullScreen();

  const resetPlayer = () => {
    playerRef.current.seekTo(0);
    playerRef.current.pause();
  };

  return { init, cleanup, playerRef, exitFullscreen, resetPlayer };
};

export default useWebGlPlayer;
